export const numberWithCommas = (n) => {
  var parts = n.toString().split(".");
  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
};

export const padRight = (message) => {
  for (let i = message.length; i < 32; i++) {
    message += `${Math.floor(Math.random() * 10)}`;
  }
  return message;
};

export const ToFixed = (number, count) => {
  const parsedNumber = parseFloat(number);

  if (count) {
    const pass = parsedNumber * count;
    const convertedNumber = Math.floor(pass);
    return convertedNumber / count;
  } else {
    const pass = parsedNumber * 100;
    const convertedNumber = Math.floor(pass);
    return convertedNumber / 100;
  }
};

export const countGenerator = ({ h, m, s }) => {
  const fill = (number) => {
    return number < 10 ? `0${number}` : number;
  };

  return `${fill(h)}:${fill(m)}:${fill(s)}`;
};

export const getTimer = (criteriaTime) => {
  const now = new Date();
  const setTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, criteriaTime, 0, 0);

  return setTime.getTime();
};

export const dateConvertor = (date, type = "full") =>
  type === "full"
    ? date.getFullYear() +
      "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + date.getDate()).slice(-2) +
      " " +
      ("00" + date.getHours()).slice(-2) +
      ":" +
      ("00" + date.getMinutes()).slice(-2) +
      ":" +
      ("00" + date.getSeconds()).slice(-2)
    : date.getFullYear() + "-" + ("00" + (date.getMonth() + 1)).slice(-2) + "-" + ("00" + date.getDate()).slice(-2);

export const noticeDateConvertor = (date) =>
  date.getFullYear() + "-" + ("00" + (date.getMonth() + 1)).slice(-2) + "-" + ("00" + date.getDate()).slice(-2);

export const YYYYMMDDTT = (date) =>
  date.getFullYear() +
  "-" +
  ("00" + (date.getMonth() + 1)).slice(-2) +
  "-" +
  ("00" + date.getDate()).slice(-2) +
  " " +
  ("00" + date.getHours()).slice(-2) +
  ":00:00";

const timeTable = {
  villa: 1000 * 60 * 60 * 24 * 3,
  building: 1000 * 60 * 60 * 24 * 4,
  hotel: 1000 * 60 * 60 * 24 * 5,
};

export const matchingDateConvertor = (date, type) => {
  //YYYYMMDDTT
  if (type) {
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);
    const time = date.substring(8, 10);
    const merged = `${year}-${month}-${day} ${time}:00:00`;
    const datetime = new Date(merged).getTime();
    const converted = datetime + timeTable[type];
    return YYYYMMDDTT(new Date(converted));
  } else {
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);
    const time = date.substring(8, 10);
    return `${year}-${month}-${day} ${time}:00:00`;
  }
};

export const emailMasking = (email) => {
  let converted = ``;
  try {
    const split = email.split("@");
    for (let i = 0; i < split[0].length; i++) {
      if (i < 3) {
        converted += split[0][i];
      } else {
        converted += `*`;
      }
    }
    converted += "@";
    for (let i = 0; i < split[1].length; i++) {
      if (i < 1) {
        converted += split[1][i];
      } else if (i > split[1].length - 5) {
        converted += split[1][i];
      } else {
        converted += `*`;
      }
    }
  } catch (e) {
    return converted;
  }

  return converted;
};
